import React from 'react';
import Navigation from '../tulote/Navigation';
import AboutSection from '../tulote/AboutSection';
import Footer from '../tulote/Footer';
import ThemeTogglerTwo from '../tulote/ThemeTogglerTwo';
import { ThemeProvider } from '../ThemeProvider';

function NosotrosPage() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
        {/* Navigation */}
        <Navigation />

        {/* About Section */}
        <section id="nosotros">
          <AboutSection />
        </section>

        {/* Footer */}
        <Footer />

        {/* Theme Toggle Button */}
        <div className="fixed bottom-6 right-6 z-50 hidden sm:block">
          <ThemeTogglerTwo />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default NosotrosPage;
